import { RouteAuthenticationRequirement, RouteItem } from '@cks-internal/react-base';
import { AppRoles } from '../constants/appRoles.ts';
import { NarrowLayout } from '../components/layout/narrowLayout.tsx';
import { ApplicationRoutes } from '../constants/appRoutes.ts';

export const PricingAdminNavItems: RouteItem = {
  text: 'Pricing Admin',
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: [AppRoles.ProductAdmin, AppRoles.SystemAdmin],
  layout: <NarrowLayout />,
  subItems: [
    {
      text: 'Manage Markup Templates',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.PricingAdmin.manageMarkupTemplates,
      allowedRoles: [AppRoles.ProductAdmin],
      async lazy() {
        const component = await import('../features/productAdmin/markupTemplateManagement/ManageMarkupTemplates.tsx');
        return { Component: component.ManageMarkupTemplates };
      }
    },
    {
      text: 'Pricing Settings',
      authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
      path: ApplicationRoutes.PricingAdmin.pricingSettings,
      allowedRoles: [AppRoles.ProductAdmin],
      async lazy() {
        const component = await import('../features/productAdmin/pricingSettings/ProductPricingSettingsPage.tsx');
        return { Component: component.ProductPricingSettingsPage };
      }
    }
  ]
};
